module.exports = __webpack_public_path__ + "static/media/responsive.4277c917.svg";